import { render } from "./WithdrawalsTab.vue?vue&type=template&id=8543e842"
import script from "./WithdrawalsTab.vue?vue&type=script&lang=js"
export * from "./WithdrawalsTab.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./WithdrawalsTab.vue?vue&type=style&index=0&id=8543e842&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script